import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '主页',
      component: home,
      redirect: { path: '/introduce' },
    },
    // {
    //   path: '/',
    //   name: '主页',
    //   component: home,
    //   children:[
    //     { path: '/wait', component: resolve => require(['../components/wait'], resolve), name: '首页' },
    //   ],
    // },
    {
      path: '/',
      name: '主页',
      component: home,
      children:[
        { path: '/index', component: resolve => require(['../components/index'], resolve), name: '首页' },
        { path: '/introduce', component: resolve => require(['../components/introduce'], resolve), name: '应用介绍' },
        { path: '/xy', component: resolve => require(['../components/xy'], resolve), name: '隐私协议' },
      ],
    },
    {
      path: '/',
      name: '城市选择',
      component: home,
      children:[
        { path: '/city', component: resolve => require(['../components/city'], resolve), name: '城市选择' },
      ],
    },
    {
      path: '/',
      name: '',
      component: home,
      children:[
        { path: '/busTrans', component: resolve => require(['../components/busTrans'], resolve), name: '乘车记录' },
      ],
    },
    {
      path: '/',
      name: '',
      component: home,
      children:[
        { path: '/error', component: resolve => require(['../components/error'], resolve), name: '错误页面' },
      ],
    },
    {
      path: '/',
      name: '',
      component: home,
      children:[
        { path: '/yq', component: resolve => require(['../components/yq'], resolve), name: '登记' },
      ],
    },
    {
      path: '/',
      name: '',
      component: home,
      children:[
        { path: '/my', component: resolve => require(['../components/my'], resolve), name: '我的' },
      ],
    },

    {
      path: '/',
      name: '',
      component: home,
      children:[
        { path: '/bindCard', component: resolve => require(['../components/bindCard'], resolve), name: '绑卡' },
      ],
    },


    {
      path: '/infoDetail',
      name: '信息查询',
      component: resolve => require(['../components/infoDetail'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js